import getConfig from 'next/config';
import { FaqComponent } from '../../components/Common/FAQS';
import { ORG_SCHEMA, WEB_SCHEMA } from '../../constants/componentStaticData';
import { ButtonVariants } from '../Atoms/Button';
import { GuidesAndUsefullLink } from '../Common/GuidesAndUsefullLink';
import { GreySection, PADDING_TYPE } from '../Common/Section/GreySection';
import { CircleTick } from '../Icons/circleTick';
import { ChevronRight } from '../Icons/rightArrow/ChevronRight';
import { TestimonialFold } from '../S/pricing/components/testimonial_fold';
import { ButtonWithAnchor } from '../income-tax/page-sections/hero-section/sticky-button';
import { StartForFreeBanner } from '../income-tax/page-sections/start-for-free-section/start-for-free';
import { ITR_DATA } from '../income-tax/static/types';
import { Itr2Hero } from './hero-section';
import { canonical, description, pageTitle } from './static/constants';
import {
  ExchangeList,
  ExchangeList2,
  GuidesAndLinksDataITR2,
  ITR_2_FAQs,
  startFilingLinkViewPlans,
} from './static/data';
const { publicRuntimeConfig } = getConfig();

interface ITR_PROPS {
  itrData: ITR_DATA;
}

export const ITR2Page = ({ itrData }: ITR_PROPS): JSX.Element => {
  return (
    <>
      <Itr2Hero data={itrData.heroSection} />

      <div className="wg-container relative bg-white mt-16 mb-28 md:mt-4 md:mb-16 sm:mb-14 sm:mt-14">
        <div className="stack across border-black justify-center mb-6 md:flex-col sm:flex sm:flex-col ">
          <h2 className=" text-s-48 border-black text-center md:text-s-40 sm:text-s-32 sm:text-start">
            Smart integration with 100+ brokers & exchanges
          </h2>
        </div>

        <div className="text-s-20  text-font-200 font-medium text-center border-black mb-12 flex items-center justify-center md:flex-col md:gap-4 sm:flex-col sm:text-base sm:gap-4 sm:text-start sm:mb-8 sm:items-start">
          One-click import of all your transactions from our integrations
          <a
            href="/itr-2-filing/integrations"
            className="text-blue-350 text-base font-bold flex cursor-pointer ml-1"
          >
            View All Integrations <ChevronRight />
          </a>
        </div>

        <div className="slider-h sm:h-20">
          <div className="slide-track animate-right w-auto">
            {ExchangeList.map((exchange) => {
              return (
                <div
                  key={exchange.id}
                  className="slide w-full sm:h-16 mx-14 sm:mx-8"
                >
                  <img
                    loading="lazy"
                    className="w-12 h-12 rounded-3xl mx-1 sm:w-8 sm:h-8"
                    src={exchange.icon}
                    alt="img"
                  />
                  <p className="px-2 text-s-16 text-font-500 whitespace-nowrap">
                    {exchange.name}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
        <div className="slider-h sm:h-20">
          <div className="slide-track animate-left w-auto">
            {ExchangeList2.map((exchange) => {
              return (
                <div
                  key={exchange.id}
                  className="slide w-full sm:h-16 mx-14 sm:mx-8"
                >
                  <img
                    loading="lazy"
                    className="w-12 h-12 rounded-3xl mx-2 sm:w-8 sm:h-8"
                    src={exchange.icon}
                    alt="img"
                  />
                  <p className="mx-2 text-s-16 text-font-500 whitespace-nowrap">
                    {exchange.name}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div
        className={`w-full bg-grey-190 ${PADDING_TYPE.half} md:pb-0 sm:pb-0`}
      >
        <div className="wg-container flex gap-12 md:flex-col sm:flex-col">
          <div className="w-1/2 md:w-full md:mb-12 sm:mb-9 sm:w-full ">
            <h2 className="text-s-48 font-bold mb-6 md:text-s-40 sm:text-s-32">
              {itrData.whyChooseSection.title}
            </h2>
            {(
              itrData.whyChooseSection.lists as Array<{
                title: string;
                desc: string;
              }>
            ).map((item) => {
              if (!item) return <></>;
              return (
                <div
                  key={item.title}
                  className="flex gap-6 items-start mb-12 sm:mb-6"
                >
                  <div className="pt-1">
                    <CircleTick />
                  </div>
                  <div>
                    <div className="text-s-20 font-semibold mb-1">
                      {item.title}
                    </div>
                    <div className="text-base text-font-200 font-medium">
                      {item.desc}
                    </div>
                  </div>
                </div>
              );
            })}
            <ButtonWithAnchor
              buttonText="Start Filing"
              isStickyOnMobile={true}
              trackLabel={`hero_fold_button`}
              buttonVariant={ButtonVariants.bluefilled}
              className="w-full"
              buttonLink={startFilingLinkViewPlans}
            />
          </div>
          <div className="w-1/2 md:w-full sm:w-full">
            <video
              className="w-full"
              autoPlay
              loop
              playsInline
              muted
              src="https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/f5c6fbd8-ecd5-46d5-97a0-da7e9f20878c.mp4"
            ></video>
          </div>
        </div>
      </div>

      <div className="wg-container pt-28 md:pt-16 sm:pt-16">
        <StartForFreeBanner
          heading="Still confused? Get Expert Assistance "
          desc="Get a dedicated expert to handle your taxes from start to finish"
          planData={{
            text: 'Our Plans starting from ',
            discountedPrice: '₹4249',
            originalPrice: '₹4999',
          }}
          button1={{
            text: 'View plans',
            url: `${publicRuntimeConfig.CLEARTAX_DOMAIN}/s/pricing`,
          }}
          priceMapData={{}}
        />
      </div>

      <div className="wg-container mt-8 sm:mt-4">
        <TestimonialFold showSecureCards={false} />
      </div>

      <GreySection>
        <GuidesAndUsefullLink
          heading={GuidesAndLinksDataITR2.heading}
          cards={GuidesAndLinksDataITR2.cards}
        />
      </GreySection>

      <div className="wg-container">
        <FaqComponent
          heading="Frequently Asked Questions"
          variant="partner"
          expanded="firstOnly"
          FAQS={ITR_2_FAQs}
          faqIconColor={'#314259'}
          isShowSchema={true}
        />
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(ORG_SCHEMA) }}
      ></script>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(
            WEB_SCHEMA({
              title: pageTitle,
              metaDesc: description,
              url: canonical,
            })
          ),
        }}
      ></script>
    </>
  );
};
